import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import Warning from 'img/error-icons/red-error-exclamationmark.svg'
import './dropdown.scss'

interface DropdownProps {
	label: string
	options: { value: string; label: string }[]
	fieldName: string
	onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
}

const Dropdown = ({ label, options, fieldName, onChange }: DropdownProps) => {
	const {
		register,
		formState: { errors },
	} = useFormContext()
	const [isHover, setIsHover] = useState(false)

	return (
		<div className="dropdown">
			<div className="form-field-header">
				<label htmlFor="select">{label}</label>
				{errors[fieldName] && (
					<div className="errorMsg">
						<div
							className={`errorText ${isHover ? 'visible' : ''}`}>
							Required field
						</div>
						<div
							onMouseEnter={() => setIsHover(true)}
							onMouseLeave={() => setIsHover(false)}>
							<img
								className="warningImg"
								src={Warning}
								alt="Invalid Value"
							/>
						</div>
					</div>
				)}
			</div>
			<select
				className="form-field"
				{...register(fieldName)}
				onChange={onChange}>
				<option key="empty" selected hidden disabled></option>
				{options.map(({ value, label }) => (
					<option key={value} value={value}>
						{label}
					</option>
				))}
			</select>
		</div>
	)
}

export default Dropdown
